import http from "./config/http-configs";

export const getRouteInfoByKey = (key) => {
    return http.get(`/mobile/route/list/info/${key}`)
}
